import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _components;

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import help from "../assets/js/help";
import { mapMutations, mapState } from "vuex";
import MyInvitationItem from "./MyInvitationItem";
import { Image as VanImage } from "vant/lib/image";
export default {
  name: "MyRedPacket",
  components: (_components = {}, _defineProperty(_components, VanImage.name, VanImage), _defineProperty(_components, "MyInvitationItem", MyInvitationItem), _components),
  data: function data() {
    return {
      info: {},
      NextInfo: {},
      recordList: [],
      dialogShow1: false,
      dialogShow2: false,
      show: false,
      showSuccess: false,
      showFails: false,
      showTip: false,
      tipInfo: "",
      integral: 0,
      errorInfo: "",
      redPacket: 1,
      index: 0,
      currentTime: "",
      recordInfo: {
        finished: false,
        refreshing: false,
        loading: true,
        loadDate: false,
        page: 1,
        limitNumber: 50
      },
      timer: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time"])), {}, {
    noticeInfo: function noticeInfo() {
      var info = "";
      this.recordList.map(function (e) {
        var nickName = e.nickName,
            integral = e.integral;
        info += "".concat(nickName, " \u62A2\u4E86").concat(integral, "\u79EF\u5206 ");
      });
      return info;
    },
    source: function source() {
      if (window.d1ev) {
        return 1;
      } else if (window.webkit) {
        return 2;
      } else {
        return 3;
      }
    },
    notEmpty: function notEmpty() {
      return Object.keys(this.info).length;
    },
    nextNotEmpty: function nextNotEmpty() {
      return Object.keys(this.NextInfo).length;
    },
    timeInfo: function timeInfo() {
      if (this.currentTime) {
        return this.currentTime;
      } else {
        return new Date().getTime();
      }
    },
    startTime: function startTime() {
      return this.info.startTimeU + "000" - 0;
    },
    endTime: function endTime() {
      return this.info.endTimeU + "000" - 0;
    },
    start: function start() {
      var _this$info$startTime;

      return (_this$info$startTime = this.info.startTime) === null || _this$info$startTime === void 0 ? void 0 : _this$info$startTime.slice(11, 16);
    },
    NextStart: function NextStart() {
      var _this$NextInfo, _this$NextInfo$startT;

      return (_this$NextInfo = this.NextInfo) === null || _this$NextInfo === void 0 ? void 0 : (_this$NextInfo$startT = _this$NextInfo.startTime) === null || _this$NextInfo$startT === void 0 ? void 0 : _this$NextInfo$startT.slice(11, 16);
    },
    NextStartTime: function NextStartTime() {
      return this.NextInfo.startTimeU + "000" - 0;
    },
    inOneDay: function inOneDay() {
      return this.lastSectionTime < 86400000;
    },
    lastSectionTime: function lastSectionTime() {
      return Math.abs(this.timeInfo - this.startTime);
    },
    NextLastSectionTime: function NextLastSectionTime() {
      return Math.abs(this.timeInfo - this.NextStartTime);
    },
    statusText: function statusText() {
      if (this.info.status === 1) {
        if (this.timeInfo < this.startTime) {
          return {
            code: 0,
            text: "未开始"
          };
        } else if (this.timeInfo > this.endTime) {
          return {
            code: 2,
            text: "已结束"
          };
        } else if (this.info.total === this.info.expend || this.info.applyNum === this.info.num) {
          return {
            code: 3,
            text: "已抢完"
          };
        } else {
          return {
            code: 1,
            text: "已开抢"
          };
        }
      } else {
        return {
          code: this.info.status,
          text: "已开抢"
        };
      }
    },
    params: function params() {
      var id = this.info.id;
      return {
        "platformSource": this.source,
        "targetId": id,
        "time": this.time,
        "token": this.token,
        "uid": this.uid - 0
      };
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations(["setShareInfo"])), {}, {
    onClickAuthentication: function onClickAuthentication() {
      console.log("去认证");
      this.showTip = false;
      window.goAttestation();
    },
    addIndex: function addIndex() {
      var _length = this.recordList.length;

      if (this.index === _length - 1) {
        this.index = 0;
      } else {
        this.index += 1;
      }
    },
    onFinishCountDown: function onFinishCountDown() {
      console.log("finish");
      this.currentTime = new Date().getTime();
    },
    resetTDk: function resetTDk() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _param$title = param.title,
          title = _param$title === void 0 ? "" : _param$title,
          _param$description = param.description,
          description = _param$description === void 0 ? "" : _param$description,
          _param$shareImgUrl = param.shareImgUrl,
          shareImgUrl = _param$shareImgUrl === void 0 ? "" : _param$shareImgUrl,
          _param$bannerImgUrl = param.bannerImgUrl,
          bannerImgUrl = _param$bannerImgUrl === void 0 ? "" : _param$bannerImgUrl;
      this.setShareInfo({
        shareTitle: title,
        shareDesc: description,
        shareImage: shareImgUrl ? "https://cdn-fs.d1ev.com/".concat(shareImgUrl, "!w360") : "",
        bannerImage: bannerImgUrl ? "https://cdn-fs.d1ev.com/".concat(bannerImgUrl, "!w480") : ""
      });
    },
    getRedpacketInfo: function getRedpacketInfo() {
      var _this = this;

      var params = "?time=".concat(this.time, "&token=").concat(this.token, "&uid=").concat(this.uid);
      this.axios.get("/api/activity/redpacket-config".concat(params)).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            //this.$set(this.info, res[0]);
            _this.info = Object.assign({}, _this.info, res[0]);

            var _info = JSON.parse(JSON.stringify(_this.info));

            _this.resetTDk(_info);

            if (res.length === 2) {
              _this.NextInfo = res[1];
            }

            console.log(res);
          }, function (err) {
            console.log(err);

            _this.setShareInfo({});

            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    getRedpacket: function getRedpacket() {
      var _this2 = this;

      this.show = true;
      setTimeout(function () {
        _this2.show = false;

        _this2.axios.post("/api/activity/redpacket-record-add", JSON.stringify(_this2.params), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        }).then(function (res) {
          if (res) {
            help.requestSuccess(res).then(function (res) {
              console.log(res);
              _this2.integral = res;
              _this2.showSuccess = true;
              _this2.redPacket = 0;
            }, function (err) {
              console.log("err", err);

              if (err.code === -2) {
                _this2.tipInfo = err.msg;
                _this2.showTip = true;
              } else {
                _this2.errorInfo = err;
                _this2.showFails = true;

                _Notify({
                  type: "warning",
                  message: err
                });
              }

              help.resError(err, true, _this2.logout, _this2.setTimeOut);
            });
          }
        }, function (err) {
          help.requestError(err);
        });
      }, 2000);
    },
    getRedpacketRecord: function getRedpacketRecord() {
      var _this3 = this;

      var id = this.info.id;
      var params = "?id=".concat(id, "&time=").concat(this.time, "&token=").concat(this.token, "&uid=").concat(this.uid, "&page=").concat(this.recordInfo.page);
      this.axios.get("/api/activity/redpacket-record-list".concat(params)).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
            _this3.recordInfo.loading = false;
            res.map(function (e) {
              _this3.recordList.push(e);
            });
            _this3.recordInfo.loading = false;
            _this3.recordInfo.page += 1;

            if (res.length < 50) {
              _this3.recordInfo.finished = true;
            }
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this3.logout, _this3.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    onLoad: function onLoad() {
      var _this4 = this;

      if (!this.timer || !this.recordInfo.loadDate) {
        this.timer = setTimeout(function () {
          _this4.getRedpacketRecord();

          _this4.timer = "";
          _this4.recordInfo.loadDate = true;
        }, 250);
      }
    },
    checkDetail: function checkDetail() {
      this.showSuccess = false;
      this.showFails = false;
      this.getRedpacketInfo(); //this.getRedpacketRecord();

      this.dialogShow1 = true;
      this.addIndex();
    },
    reset: function reset() {
      this.onFinishCountDown();
    }
  }),
  created: function created() {
    window.resetList = this.reset;
  },
  mounted: function mounted() {
    this.getRedpacketInfo();
  }
};